import Vue from "vue";

import { API_ROOT_INTEGRATIONS, integrations, participant, participantDataErrors, selection, study, vendors, studyManagement, featureFlags } from "./urls";

const integrationsResource = Vue.resource(
  `${API_ROOT_INTEGRATIONS}${integrations}/${vendors}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const integrationsVendorSelectionResource = Vue.resource(
  `${API_ROOT_INTEGRATIONS}${integrations}/${vendors}/${selection}/${study}/{studyId}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

const createIntegrationsVendorSelectionResource = Vue.resource(
  `${API_ROOT_INTEGRATIONS}${integrations}/${vendors}/${selection}`,
  {},
  {
    update: {
      method: "POST"
    }
  }
);

const integrationsParticipantDataErrorsResource = Vue.resource(
  `${API_ROOT_INTEGRATIONS}${integrations}/${participantDataErrors}/${participant}/{participantId}`,
  {},
  {
    update: {
      method: "PUT"
    }
  }
);

export const featureFlagsResource = Vue.resource(`${API_ROOT_INTEGRATIONS}${studyManagement}${featureFlags}`);

export function saveIntegrationVendorSelection(selectionDetails) {
  return createIntegrationsVendorSelectionResource.save(selectionDetails);
}

export function getIntegrationVendors() {
  return integrationsResource.get();
}

export function getIntegrationVendorSelection(studyId) {
  return integrationsVendorSelectionResource.get({ studyId });
}

export function updateIntegrationVendorSelection(studyId, data) {
  return integrationsVendorSelectionResource.update({ studyId }, data);
}

export function deleteIntegrationVendorSelection(studyId) {
  return integrationsVendorSelectionResource.delete({ studyId });
}

export function deleteIntegrationParticipantError(participantId) {
  return integrationsParticipantDataErrorsResource.delete({ participantId });
}

export function getAllFeatureFlags() {
  return featureFlagsResource.get();
}